var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#468EE3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.668 4.2a.627.627 0 0 0-.44.205C9.64 6.07 7.94 7.979 6.353 9.663L4.088 7.712a.62.62 0 0 0-.655-.156.663.663 0 0 0-.427.543c-.033.251.072.5.272.643l2.72 2.345a.62.62 0 0 0 .86-.042c1.72-1.804 3.586-3.917 5.28-5.693a.692.692 0 0 0 .144-.745.639.639 0 0 0-.614-.406z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.dc3e078a.svg";
export { ForwardRef as ReactComponent };